export const ResultEnum = {
  SUCCESS: 'SUCCESS',
  IGNORED: 'IGNORED',
  FAILED: 'FAILED',
  PENDING: 'PENDING'
};

export const LayoutTypeEnum = {
  SYSTEM: 0,
  USER: 1,
  DEFAULT: 2
};

export const ProcessReceiptStatus = {
  Concept: 1,
  Processed: 2
};

export const ArticleType = {
  Sale: 1,
  Rental: 2
};

export const StockType = {
  Bulk: 0,
  Unique: 1
};

export const AccessLevels = {
  NotSet: -99,
  Revoke: 0,
  Grant: 1
};

export const Actions = {
  Create: '1.3',
  Read: '1.1',
  Update: '1.2',
  Delete: '1.4',
  CreateOrUpdate: '1.5',
  Execute: ''
};

export const ColumnType = {
  Text: 0,
  ApplicationLink: 1,
  Image: 2
};

export const MutationState = {
  Create: 0,
  Update: 1,
  Delete: 2,
  None: -1
};

export const TransportTypes = {
  None: 0,
  Car: 1,
  CarWithTrailer: 2,
  SmallVan: 3,
  Van: 4,
  Truck: 5
};

export const WorkFlowKinds = {
  Incident: 1,
  WorkOrder: 2
};

export const MeasuringDeviceKind = {
  MeterPosition: 1,
  MeasuringDevice: 2
};

export const LifeSpanCalculationMethod = {
  None: 0,
  ConstructionYear: 1,
  CreateDate: 2
};

export const HorizontalAlign = {
  General: 0,
  Left: 1,
  Right: 2,
  Center: 3
};

export const FieldTypes = {
  Bit: 2,
  SmallInt: 16,
  Int: 8,
  Decimal: 5,
  DateTime: 33,
  NVarChar: 12,
};

export const ColumnFormat = {
  Number: 1,
  Currency: 2,
  ShortTime: 3,
  LongTime: 4,
  ShortDate: 5,
  LongDate: 6,
  UpperCase: 7,
  Percentage: 8
};

export const MIValidUntilDateCalculationMethods = {
  Default: 0,
  EndOfMonth: 1
};

export const TimeUnits = {
  Minutes: 1,
  Hours: 2,
  Days: 3,
  Weeks: 4,
  Months: 5,
  Quarters: 6,
  Years: 7,
  HalfYears: 8
};

export const NextRunCalculationMethods = {
  OnLastSuccessfulRun: 0,
  OnLastRun: 1
};

export const WorkFlowSystemSettingDefaultAnswers = {
  Always: 1,
  Never: 2,
  Custom: 3
};

export const Visibility = {
  Hidden: 0,
  Visible: 1,
  VisibleWhenEmpty: 2
};

export const PlanItemType = {
  WorkingTicket: 'workingticket',
  LeaveHour: 'leavehour',
  NonProductiveHour: 'nonproductivehour',
  Picklist: 'picklist'
}; 

export const WeekViewColumnWidths = {
    Small: 0 ,
    Average: 1,
    Wide: 2
};

export const WeekViewTimeUnits = {
    HalfHour: 0,
    OneHour: 1,
    TwoHours: 2,
    FourHours: 4,
    EightHours: 8
};

export const ArticleTypes = {
  Sale: 1,
  Rental: 2
};

export const DropShipments = {
  DontAllowDropShipment: 0,
  AllowDropShipment: 1,
  DefaultDropShipment: 2,
  DropShipmentRequired: 3
};

export const RoundOffMethods = {
  Scientific: 0,
  Up: 1
};

export const Genders = {
  Male: 1,
  Female: 2,
  Unknown: 3
};

export const ProcessMethods = {
  CopyTemplate: 0,
  CopyCalculation: 1
};

export const InputComponentType  = {
  BoolInput: 0,
  DateTimeInput: 1,
  ListInput: 2,
  NumericInput: 3,
  SelectInput: 4,
  TextAreaInput: 5,
  TextInput: 6,
  Variable: 99,
  Code: 98
};

export const DropShipment = {
  DontAllowDropShipment: 0,
  AllowDropShipment: 1,
  DefaultDropShipment: 2,
  DropShipmentRequired: 3
};

export const OrderStatus = {
  Basket: -1,
  OfferRequest: 0, // Offer / Request
  NotAuthorized: 1,
  Order: 2,
  Supply: 3,
  Backorder: 4,
  RentalOutstanding: 5,
  Completed: 6,
  Cancelled: 7,
  Authorized: 8,
  Refused: 9,
  OfferRequest_Refused: 13
};

export const OrderCostMethodCalculation = {
  Order: 0,
  Shipment: 1
};

export const TransportMethodCalculation = {
  Order: 0,
  Shipment: 1
};

export const InvoicePeriodUnit = {
  Daily: 3,
  Weekly: 4,
  Monthly: 5,
  Quarterly: 6,
  HalfYearly: 8,
  Yearly: 7,
  Completely: 10,
};

export const ObjectViewLimitations = {
  None: 0,
  OwnRelation: 1,
  LocationAuthorization: 2,
  OwnRelationHierarchical: 3
};

export const LocationViewLimitations = {
  None: 0,
  OwnRelation: 1,
  LocationAuthorization: 2,
  OwnRelationHierarchical: 3
};

export const WorkFlowViewLimitations = {
  None: 0,
  RelationWFIs: 1,
  ContactPersonWFIs: 2,
  UserWFIs: 3,
  OwnRelationHierarchical: 4
};

export const RelationViewLimitations = {
  None: 0,
  OwnRelation: 1,
  OwnRelationHierarchical: 2
};

export const NewUserRequestViewLimitations = {
  None: 0,
  OwnRelation: 1,
  OwnRelationHierarchical: 2
};

export const OrderViewLimitations = {
  None: 0,
  DeliverRelation: 1,
  DeliverRelationHierarchical: 2,
  ContactPerson: 3,
  DeliverLocationUser: 4
};

export const InvoiceViewLimitations = {
  None: 0,
  InvoiceRelation: 1,
  ConcernRelation: 2,
  ContactPerson: 3,
  DeliveryLocationUser: 4
};

export const UseLastUsedFilterValues = {
  Never: 0,
  Always: 1
};   

export const WorkFlowTypes = {
  Incident: 1,
  WorkOrder: 2
};

export const OverwriteInspectorMode = {
  Never: 0,
  OnlyWhenEmpty: 1,
  Always: 2
};   

// centix objectstate (IObjectWithState)
export const ObjectState = {
  Unchanged: 0,
  Added: 1,
  Modified: 2,
  Deleted: 3
};

export const BudgetCodeTypes = {
  Consumables: 1,
  Labor: 2,
  Equipment: 3,
  Generic: 0
};

export const PickListArea = {
  Warehouse: 0,
  WarehouseLocation: 1
};

export const DeliverOffSet = {
  All: 0,
  Tomorrow: 1,
  TwoDays: 2,
  ThreeDays: 3
};

export const MailEDI = {
  None: 0,
  Default: 1,
  Custom: 99
};

export const MergeInvoiceOption = {
  None: 0,
  MergePerInvoiceRelation: 1,
  MergePerDeliverLocation: 2,
  MergePerDeliverAddress: 3
};

export const ContractCompaction = {
  None: 0,
  Relation: 1
};

export const ContractInvoiceReferences = {
  None: 0,
  Contract: 1,
  Period: 2,
  All: 3
};

export const ContractPricingType = {
  TimeAndMaterials: 0,
  ContractPrice: 1,
  ObjectPrices: 2,
  ConfigurationValue: 3
};

export const ContractInitialInvoiceType = {
  CalenderPeriod: 0,
  ContractPeriod: 1
};

export const InvoiceLineObjectContractCompreses = {
  None: 0,
  ObjectTypePrice: 1,
  SingleRow: 2
};

export const PurchaseOrderStatus = {
  OfferRequest: -1,
  Concept: 0,
  NotAuthorized: 1,
  Order: 2,
  Supply: 3,
  Backorder: 4,
  RentalOutstanding: 5,
  Completed: 6,
  Authorized: 8,
  Refused: 9
};

export const PurchaseOrderLineType = {
  Sale: 1,
  Rental: 2,
  Comment: 4
};

export const MIStatus = {
  Open: 0,
  Finished: 1,
  Waiting: 2,
  ReOpened: 3
};

export const InvoiceStatus = {
  New: 0,
  Completed: 1,
  ConceptRequest: 2,
	Voided: 3
};

export const UserEvents ={
  New : 0,
  NewWithActionLink : 1,
  Locked : 2,
  MaxLoginAttemptsExceeded : 3,
  AccountExpired : 4,
  ResetPassWord : 5,
  PassWordChanged : 6,
  Unlocked : 7
};

export const CalculateExecuteAtEnums ={
  LogDate: 0
};

export const Delay ={
  None: 0,
  Before: 1,
  After: 2
};
export const InvoiceLineType = {
  Sale: 1,
  Rental: 2,
  Comment: 4
};

export const TradeItemType ={
  Order: 1,
  PurchaseOrder: 3,
  Invoice: 2,
  PurchaseInvoice : 4
};

export const BooleanNotation = {
  TrueFalse: 1,
  YesNo: 2,
  TF: 3,
  YN : 4,
  OneZero : 5
};

export const DecimalNotation = {
  Comma: 1,
  Dot: 2
};

export const ExportLayout = {
  ImportLayout: 1,
  GridLayout: 2
};

export const DateTimeNotation = {
  DMYYYY: 1,
  DMYYYY_Dash: 2,
  DDMMYYYY: 3,
  MDYYYY : 4,
  MDYYYY_Dash : 5,
  MMDDYYYY : 6
};

export const LocationKinds = {
  Default: 0,
  Person: 1,
  Project: 2
};
export const ReportType = {
  SystemReport: 2,
  UserReport: 3
};

export const ProcessWorkflowItemCollectBy = {
  None: 0,
  Relation: 2
};

export const WorkflowCompaction = {
  None: 0,
  WFICompaction: 1,
  WFITreeCompaction: 2,
  All: 3
};

export const QuestionType = {
  Question: 1,
  Measurement: 2,
  Remark: 3,
  Automated: 4
};

export const AnswerType = {
  OKFailedNa: 0,
  YesNoNa: 1
};

export const AnswerTypeOKFailedNa = {
  NoAnswer: 0,
  OK: 1,
  Failed: 2,
  Na: 3
};

export const AnswerTypeYesNoNa = {
  NoAnswer: 0,
  Yes: 1,
  No: 2,
  Na: 3
};

export const FieldClientProcessedStatus = {
  New: 0,
  Send: 1,
  Failed: 2
};

export const MoveBasketStatus = {
  Concept: 0,
  Processed: 4
};

export const CalculateExecuteAtBy = {
  LogDate: 0
};

export const MoveBasketEvents = {
  StatusChange: 0
};

export const MIPlanType = {
  GenericMIPlan: 0,
  ObjectMIPlan: 1,
  ObjectTypeMIPlan: 2
};

export const PriceListTypes = {
  Sale: 0,
  Purchase: 1,
  ObjectRental: 2
};

export const DayBookType = {
  PUR: 0,
  SAL: 1,
  REV: 2,
  DRA: 3,
  STO: 4,
  DEP: 5
};

export const AccountingPeriod = {
  Month: 0,
  Period: 1
};

export const WorkingTicketCharge = {
  InvoiceWTNo: 0,
  InvoiceWTFacturation: 1,
  InvoiceWTExportXML: 2
};

export const WorkFlowCharge = {
  InvoiceWFINo: 0,
  InvoiceWFIFacturation: 1,
  InvoiceWFIExportXML: 2
};

export const ContractCharge = {
  InvoiceContractNo: 0,
  InvoiceContractFacturation: 1,
  InvoiceContractExportXML: 2
};

export const AllowDuplicateObjects = {
  Never: 0,
  SingleActive: 1,
  Always: 2
};

export const ObjectMIVisitCountWhen = {
  OnResult: 0,
  OnOkResult: 1
};
export const ContractEvents = {
  StatusChange: 0
};

export const ContractCalculateExecuteAtBy = {
  LogDate: 0
};

export const NewUserRequestStatus = {
  New: 0,
  Refused: 1,
  ExistingUser: 2,
  NewUser: 3
};

export const NewUserRequestEvents = {
  StatusChange: 0,
  Expired: 1
};

export const PurchaseOrderEvents = {
  StatusChange: 0
};
export const InvoiceEvents = {
  StatusChange: 0
};

export const InvoiceCalculateExecuteAt = {
  LogDate: 0,
  OrderDate: 1,
  DeliverDate: 2,
  InvoiceDate: 3
};

export const PurchaseInvoiceCalculateExecuteAt = {
  RegistrationDate: 0,
  InvoiceDate: 1
};

export const PurchaseInvoiceStatus = {
  Concept: 0,
  Completed: 1
};

export const PurchaseProposalType = {
  Central: 0,
  Warehouse: 1
};

export const ObjectScenario = {
    None: 0,
    ArticleDriven: 1,
    ObjectTypeDriven: 2,
    BrandDriven: 3
};

export const PickListStatus = {
  Open: 0,
  Picked: 1,
  Packed: 2,
  Split: 3
};
export const LocationEvents = {
  StatusChange: 0
};

export const WorkingTicketEvents = {
  StatusChange: 0,
  ResponsibleEmployeeChange : 1
};

export const WorkingTicketCalculateExecuteAtEnum = {
  LogDate: 0,
  StartDate : 1,
  EndDate: 2
};

export const AdvancedFilterType = {
  None: -1,
  Default: 0,
  Bool: 1,
  Number: 2,
  DecimalNumber: 3,
  DateTime: 4
};

export const CapacityPlanType = {
  ObjectOIschema: 1,
  WFI: 2,
  rWFI: 3,
  Manual: 4
};

export const PersonRequirementResults ={
  Unknown: 0,
  Passed: 1,
  Failed: 2,
  NotReviewed: 3
};

export const RequirementExpirationCalculationMethod ={
  Default: 0,
  EndOfMonth: 1
};

export const CapacityPlanLogEvents = {
  Add: 0,
  Remove: 1,
  Edit: 2,
};

export const LifespanExpiresOn = {
  ExactDate: 0,
  EndOfMonth: 1,
  EndOfYear: 2
};

export const ConstructionYearFormat = {
	NONE: -1,
  YYYY: 0,
  MM_Dash_YYYY: 1,
  MM_Slash_YYYY: 2,
  YYYY_Dash_MM: 3,
  YYYY_Slash_MM: 4,
  DD_Dash_MM_Dash_YYYY: 5,
  MM_Dash_DD_Dash_YYYY: 6,
  YYYY_Dash_MM_Dash_DD: 7,
  DD_Slash_MM_Slash_YYYY: 8,
  MM_Slash_DD_Slash_YYYY: 9,
  YYYY_Slash_MM_Slash_DD: 10,
  YYYYMMDD: 11
};

export const WorkFlowEvents = {
  StatusChange: 0,
  EmployeeChange : 1
};

export const PropertyVisibility = {
  OnlyRequiredProperties: 1,
  AllProperties : 2,
  OnlyRequiredProperties_ReadOnly: 3,
  AllProperties_ReadOnly : 4
};

export const DefaultConcernRelation = {
  None: 0,
  UserRelation : 1
};
export const VatType = {
  Sales: 0,
  Purchase: 1,
  Combined: 2
};
export const ReturnRequestEvents = {
  StatusChange: 0
};
export const ReturnRequestStatusses = {
  Concept: 0,
  Submitted: 1,
  Approved: 2,
  Partial_Approve: 3,
  Rejected: 4,
  Cancelled: 5
};
export const ReturnRequestApprovals = {
  None: 0,
  Approved: 1,
  Rejected: 2
};
export const ProcessWorkingTicketCollectBy = {
  None: 0,
  WorkFlowItem: 1,
  Relation: 2
};
export const OffsetUnitEnum = {
  Hours: 1,
  Days: 2
};
export const AutoAddUserToWorkFlowUsers ={
  Always : 1,
  Never: 2,
  Ask: 3
};
export const PositionNumberSystem ={
  None : 0,
  WFI: 1,
  Employee: 2,
  WFI_Employee : 3,
  Total: 4,
  WorkPlace: 5
};
export const DefaultPositionNewWFI = {
  Top: 0,
  Bottom: 1
};

export const ProcessWFICollectBy = {
  None: 0,
  Relation: 2
};
export const FixedPriceWorkDefaultDescription ={
  None : 0,
  Order: 1,
  OrderLine: 2
};
export const FixedPriceWorkDefaultWorkFlowKind ={
  Empty : 0,
  Incident: 1,
  WerkOrder: 2
};

export const DefaultLocationIDGenerator ={
  None : 0,
  LocationType: 1,
  Number: 2,
  Relation : 3
};

export const AutoAddOrRemoveToSubLocation  ={
  Always : 1,
  Never: 2,
  Ask: 3
};

export const DefaultDrivenDescr ={
  None : 0,
  LocationTypeDescr: 1,
};

export const PackListEvents = {
  StatusChange: 0,
  DeliverDateChange: 1,
};

export const UniqueProjects = {
  Database: 0,
  Relation: 1,
  Administration: 2
};

export const EInvoiceType = {
  WorkingTicket: 0,
  Contract: 1,
  Order: 2,
  WorkFlowItem: 3,
  Invoice: 4
};

export const EInvoiceLineTypes = {
  Default : 0,
  FixedPrice: 1,
  Discount: 2,
  Comment: 3,
  Rental: 4,
  HourRegistration: 5,
  ArticleRealization: 6,
};

export const EInvoiceProcessStates = {
  NotSet: 0,
  CreateSuccess: 1,
  OverwriteSuccess: 2,
  CreateFailed: 3,
  OverwriteFailed: 4,
  Skipped: 5,
  Failed: 6,
  Pending: 7
};

export const EInvoicesViewDataSetFilter = {
  NotProcessed: 0,
  Ignored: 1,
  Processed: 2
};

export const NextRunCalculationMethod = {
  OnLastSuccessfulRun: 0,
  OnLastRun: 1
};

export const ObjectMIScheduleResult = {
  Ok: 1,
  Failed: 2,
  Na: 3
};

export const OrderLineSorting = {
  PositionNumber: 0,
  ProductNumber: 1
};

export const OrderLinesMatching = {
  None: 0,
  MatchHeader: 1,
  Ask: 2,
};

export const DeviceTypes = {
  Device: 0,
  Installation: 1,
  Combination: 2,
};

export const ProjectEvents = {
  StatusChange: 0,
  AssignedToChange: 1
};

export const WTValidations = {
  None: 0,
  Warning: 1,
  Error: 2
};
export const WTRoundOffEndTimes = {
  Minutes5: 0,
  Quarter: 1,
  Halfhour: 2
};

export const WTShowRelationNotes = {
  Hidden: 0,
  ShowBlockReason: 1,
  ShowNotes: 2,
  ShowBlockReasonAndNotes: 3
};

export const MobileSystemSettingServiceStatus = {
  Disable: 0,
  Enable: 1,
  Suspend : 2
};

export const IssueBetweenReceivers = {
  Allow: 0,
  AllowSameRelation: 1,
  Deny: 2
};

export const UpdateRoutine = {
  Automatically: 0,
  AfterWeek: 1,
  AfterTwoWeeks: 2,
  AfterAgreement: 3
};

export const ObjectAlertSystemSettingInterval = {
  Weekly: 1,
  Monthly: 2
};
export const ObjectAlertSystemSettingWeekly = {
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
  Sunday: 7,
};
export const ObjectAlertSystemSettingMonthly= {
  Monthly_1:1,
  Monthly_2:2,
  Monthly_3:3,
  Monthly_4:4,
  Monthly_5:5,
  Monthly_6:6,
  Monthly_7:7,
  Monthly_8:8,
  Monthly_9:9,
  Monthly_10:10,
  Monthly_11:11,
  Monthly_12:12,
  Monthly_13:13,
  Monthly_14:14,
  Monthly_15:15,
  Monthly_16:16,
  Monthly_17:17,
  Monthly_18:18,
  Monthly_19:19,
  Monthly_20:20,
  Monthly_21:21,
  Monthly_22:22,
  Monthly_23:23,
  Monthly_24:24,
  Monthly_25:25,
  Monthly_26:26,
  Monthly_27:27,
  Monthly_28:28,
};

export const ProjectToProjectReturnPolicy = {
  ReturnOnDeliveryDay: 1,
  ReturnDayBeforeDeliveryDay: 2
};
export const ReportExportExtensions = {
  PDF: 0,
  XLS: 1
};

export const FixedPriceWorkRoundHours = {
  None: 0,
  QuarterUp: 1,
  HourUp : 2
};

export const FixedPriceWorkRoundProducts = {
  None: 0,
  Up: 1,
  TensUp : 2,
	HundredsUp: 3
};

export const FixedPriceWorkSorting = {
  Hours_Products: 1,
  Products_Hours : 2
};

export const TimeScheduleType = {
  Daily: 1,
  Weekly : 2,
  Monthly: 3,
  Free : 4
};

export const TimeScheduleOccursEvery = {
  Minutes: 1,
  Hours : 2,
  Day: 3,
  Weeks: 4,
  Months : 5
};

export const TimeScheduleDayOfWeek = {
  Sunday: 0,
  Monday: 1,
  Tuesday : 2,
  Wednesday: 3,
  Thursday: 4,
  Friday : 5,
  Saturday : 6
};

export const TimeScheduleWeekDayIndex= {
  First: 1,
  Second : 2,
  Third: 3,
  Last : 4
};

export const RetentionPeriod = {
  Weeks: 0,
  Months: 1,
	Years : 2
};

export const DocumentImportItemStatus = {
  New: 0,
  FileNotFound: 1,
  ReadyToImport: 2,
  ImportSucceeded: 3,
  ImportFailed: 4
};
export const DocumentImportStatus = {
  New: 0,
  Busy: 1,
  ImportSucceeded: 2,
  ImportSucceededWithWarnings: 3,
  ImportFailed: 4
};
export const DocumentImportType = {
  Document: 0,
  ProductDocument: 1,
  ObjectDocument: 2,
  ObjectTypeDocument: 3,
  RecurringWorkFlowDocument: 4,
};

export const ProductFilterOptions = {
  ProductID_Asc: 0,
  ProductID_Desc: 1,
  ProductDescr_Asc: 2,
  ProductDescr_Desc: 3,
  ProductPosition_Asc: 4,
  ProductPosition_Desc: 5
};

export const RecurringWorkflowTypes = {
  Recurring: 1,
  Manual: 2
};